export enum PagingType {
    InfiniteScroll = 'infiniteScroll',
    ClientPagination = 'clientPagination',
    ServerPagination = 'serverPagination',
}
